module.exports = __webpack_public_path__ + "3ef695fd4f24019d6d3464a3beb7d176.MP3";